export const generateApiUrl = (appendix: string) => {
    return process.env.GATSBY_API_URL !== ""
        ? `${process.env.GATSBY_API_URL}/api/${appendix}`
        : `/api/${appendix}`;
};
